import * as React from 'react';
import { StyleDataService, SurveyVersionDataService, Auth } from '../../services';
import { Style, SurveyVersion } from '../../models';
import { NavLink } from 'react-router-dom';
import { DataGrid, PVAPage } from '../../components';
import { BaseRouteProps } from '../../interfaces';
import { UserStore } from '../../stores';
import { Roles } from '../../stores/Constants';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';

interface StyleListState {
    entities: Array<Style>;
    surveyIsPublished: boolean;
}

interface StyleListingProps extends BaseRouteProps<{ id: number }> {
    UserStore?: UserStore;
    Auth?: Auth;
}

@inject('UserStore', 'Auth') @observer
export class StyleListing extends React.Component<StyleListingProps, StyleListState> {
    private styleDataService = new StyleDataService(this.props.notificationService);
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);

    @computed get isSuperAdmin() {
        return this.props.Auth!.userRoleIn([Roles.SuperAdmin]);
    }

    constructor(props: StyleListingProps) {
        super(props);

        this.state = {
            entities: new Array<Style>(),
            surveyIsPublished: true
        };
    }

    public componentDidMount() {
        this.surveyVersionDataService.get(this.props.match.params.id).then((surveyVersion: SurveyVersion) => {
            this.setState({
                surveyIsPublished: surveyVersion.published !== null ? true : false
            });

            this.styleDataService.getAllBySurveyVersionId(surveyVersion!.id).then((resp: Style[]) => {
                this.setState({
                    entities: resp
                });
            });
        });
    }

    public render() {
        const listData = this.state.entities.map(entity => {
            return {
                'Name': entity.name + ` (${entity.core})`,
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <NavLink className="btn btn-default btn-block" to={`/style/${value}`}>View</NavLink>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Buttons>
                        <NavLink to={'/surveyversion/' + this.props.match.params.id}>
                            <span className="glyphicon glyphicon-arrow-left" />
                        </NavLink>
                        {(this.isSuperAdmin && !this.state.surveyIsPublished) &&
                            <NavLink to={'/surveyversion/' + this.props.match.params.id + '/styles/create'}>
                                <span className="glyphicon glyphicon-plus" />
                            </NavLink>
                        }
                    </PVAPage.Header.Buttons>
                    <div className="title">Styles on Survey</div>
                </PVAPage.Header>

                <PVAPage.Body>
                    <DataGrid entities={listData} columns={columnDefs} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/style/StyleListing.tsx